// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__thPIw","savePackageButton":"ClientWallet_savePackageButton__BGQcI"};